import request from '../../utils/request'

export const logout = (data: RequestData) => {
  return request('logout', {
    method: 'post',
    data,
  })
}

export const getUserInfo = (data: RequestData) => {
  return request('getUserInfo', {
    method: 'post',
    data,
  })
}

export const getUserResources = (data: RequestData) => {
  return request('getUserResources', {
    method: 'post',
    data,
  })
}

export const getWeather = (data: RequestData) => {
  return request('getWeather', {
    method: 'post',
    data,
  })
}
